// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2qVPq","insightsList":"newBusinessInsightsMenu_insightsList__mBlTV","active":"newBusinessInsightsMenu_active__26n7Z"};